import { Stack } from "@mui/material";
import { type FC } from "react";
import type { FollowUpPageState } from "../../reducer/actions";
import { FollowUpPublishButton } from "./follow-up-publish-button";
import { FollowUpSaveDraftButton } from "./follow-up-save-draft-button";
import { FollowUpSentTestButton } from "./follow-up-sent-test-button";
import type { FollowUpButtonsProps } from "./types";

export const FollowUpSaveButtons: FC<
  FollowUpButtonsProps & {
    disabled: FollowUpPageState["derivedData"]["uiDisabled"]["buttons"];
  }
> = ({ disabled, ...props }) => {
  return (
    <Stack direction="row" spacing={2}>
      <FollowUpSentTestButton {...props} disabled={disabled.sendTest} />
      <FollowUpSaveDraftButton {...props} disabled={disabled.save} />
      <FollowUpPublishButton {...props} disabled={disabled.publish} />
    </Stack>
  );
};
